/// <reference path="../../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox {

    export interface ProductPickerOptions {
        hideProducts?: string;
    }

    import fld = Administration.UserRow.Fields;

    @Serenity.Decorators.registerClass()
    export class AgentCheckGrid extends NoboxEntityGrid<Administration.UserRow, ProductPickerOptions> {

        protected getColumnsKey() { return DivisionAgentColumns.columnsKey; }
        //protected getDialogType() { return <any>Nobox.Administration.UserDialog; }
        protected getIdProperty() { return Administration.UserRow.idProperty; }
        protected getLocalTextPrefix() { return Administration.UserRow.localTextPrefix; }
        protected getService() { return Administration.UserService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery, options: ProductPickerOptions) {
            super(container, options);

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getQuickFilters() {
            var flt = super.getQuickFilters();
            return flt;
        }
        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }


        protected usePager() {
            return false;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != 'add-button');
            return buttons;
        }

        get selectedItems() {
            return this.rowSelection.getSelectedAsInt32().map(x => this.view.getItemById(x));
        }

        onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var request = this.view.params as Administration.UserListRequest;
            ////request.ColumnSelection = 1;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //if (this.options.hideProducts)
            //    request.EqualityFilter = { Roles: ["3"] };
            //    request.DivisionIdsPicker = this.options.hideProducts;

            return true;
        }
    }
}